/**
 * opora-structured-payload.js — Phase D6: per-tool JSON output hints
 */
(function (global) {
  'use strict';

  var SCHEMAS = {
    'bid-drafter': { type: 'object', properties: { proposal_markdown: { type: 'string' }, line_items: { type: 'array' }, margin_pct: { type: 'number' } } },
    'rfp-decoder': { type: 'object', properties: { summary: { type: 'string' }, requirements: { type: 'array' }, bid_drafter_prefill: { type: 'object' } } },
    'margin-sentinel': { type: 'object', properties: { summary: { type: 'string' }, at_risk_accounts: { type: 'array' }, margin_pct: { type: 'number' } } },
    'compliance-agent': { type: 'object', properties: { compliance_summary: { type: 'string' }, exclusions: { type: 'array' } } },
    'lost-bid-autopsy': { type: 'object', properties: { analysis: { type: 'string' }, client_name: { type: 'string' }, lessons: { type: 'array' } } },
    'customer-recovery': { type: 'object', properties: { recovery_plan: { type: 'string' }, account_name: { type: 'string' } } },
    'review-response': { type: 'object', properties: { review_response: { type: 'string' }, tone: { type: 'string' } } }
  };

  function toolSlug() {
    var m = document.querySelector('meta[name="opora:tool-slug"]');
    return m ? m.content : '';
  }

  function enrich(body) {
    var base = body && typeof body === 'object' ? Object.assign({}, body) : {};
    var slug = toolSlug();
    if (slug && SCHEMAS[slug]) {
      base.response_schema = SCHEMAS[slug];
      base.structured_output = true;
    }
    if (!base.brand_voice) base.brand_voice = 'operator_direct';
    base.banned_phrases = base.banned_phrases || [
      'as an ai', 'in today\'s fast-paced world', 'delve', 'game-changer', 'rest assured'
    ];
    return base;
  }

  function patchFetchApi() {
    var edge = global.OporaEdge;
    if (!edge || edge.__structuredPatched || typeof edge.fetchApi !== 'function') return;
    var orig = edge.fetchApi.bind(edge);
    edge.fetchApi = function (path, opts) {
      opts = opts || {};
      var resolved = edge.resolveApiPath ? edge.resolveApiPath(path) : path;
      if (opts.body && typeof opts.body === 'string' && /\/api\/(ask|tool|render)/.test(resolved)) {
        try {
          opts.body = JSON.stringify(enrich(JSON.parse(opts.body)));
        } catch (e) {}
      }
      return orig(resolved, opts);
    };
    edge.__structuredPatched = true;
  }

  function init() {
    patchFetchApi();
    if (!global.OporaEdge) {
      var t = 0;
      var iv = setInterval(function () {
        patchFetchApi();
        if ((global.OporaEdge && global.OporaEdge.__structuredPatched) || ++t > 50) clearInterval(iv);
      }, 100);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  global.OporaStructured = { enrich: enrich, schemas: SCHEMAS };
})(window);
